import { useEffect } from "react";
import clg from "./log";

/**
 * Hook that alerts clicks outside of the passed ref
 */

/**
 * @param {ref} ref - Elem, amin kívül kattintva szeretnénk, ha lefutna a cb.
 * @param {function} cb - Callback függvény, ami akkor fut le, ha a megadott elemen kívül kattintunk.
 * @param {string} maxParentID - Meddig menjen ki a megadott elemtől számítva a DOM-ban, amin kívül kattintva fusson le a cb.
 */

function useOutsideAlerter(ref, cb = null, maxParentID) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            //clg("handleClickOutside: ", maxParentID)

            if( !maxParentID ) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if( typeof cb === "function" ) cb();
                }
            }

            if( maxParentID ) {
                //clg("maxParentID: ", maxParentID, "current: ", ref.current, "target: ", event.target, "ID: ", event.target.id, `van-e parent ${maxParentID}-val`, Boolean(event.target.closest(`#${maxParentID}`)))
                //if( ref.current && !ref.current.contains(event.target) && )
            }
            
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default useOutsideAlerter;